import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const CardFormContainer = styled(Box)(() => ({
  padding: '0 1.5em 0.2em 1.5em',
}));

export const FormSectionTitle = styled(Typography)(() => ({
  fontSize: '1em',
  fontWeight: 500,
  marginBottom: '0.8em',
  color: 'rgba(0, 0, 0, 0.87)',
}));

export const StripeBadge = styled('span')(() => ({
  display: 'inline-block',
  fontSize: '0.7em',
  fontWeight: 700,
  padding: '0.15em 0.5em',
  borderRadius: '3px',
  marginLeft: '0.5em',
  verticalAlign: 'middle',
  background: '#635bff',
  color: '#fff',
}));

export const PaymentElementWrapper = styled(Box)(() => ({
  marginBottom: '1em',
}));

export const StripeSecureNote = styled(Typography)(() => ({
  fontSize: '0.7em',
  color: 'rgba(0, 0, 0, 0.6)',
  marginTop: '0.25em',
  fontStyle: 'italic',
}));

export const FormGroup = styled(Box)(() => ({
  marginBottom: '1em',
}));

export const FormLabel = styled('label')(() => ({
  display: 'block',
  fontSize: '0.86em',
  fontWeight: 500,
  color: 'rgba(0, 0, 0, 0.6)',
  marginBottom: '0.3em',
}));

export const FormRow = styled(Box)(() => ({
  display: 'flex',
  gap: '1em',
}));

export const Divider = styled(Box)(() => ({
  height: '1px',
  background: 'rgba(0, 0, 0, 0.12)',
  margin: '0.8em 0',
}));

export const BillingAddressSection = styled(Box)(() => ({
  marginTop: '0.5em',
  paddingTop: '0.5em',
}));

export const FieldError = styled(Typography)(() => ({
  fontSize: '0.8em',
  color: '#d32f2f',
  marginTop: '0.25em',
}));
